export default import.meta.ROLLDOWN_FILE_URL_r_WVoSzsPqTwSQW9l5Tx6g